export default __webpack_public_path__ + "static/elyxr-page-animation-sample.webmsd-31b61f6b815a92259cd5f41ca692e374.webm";